var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-overlay',{ref:"customOverlay",staticClass:"samp",attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}},[_c('span',{staticClass:"map-info-box-2",class:{ 'map-info-yellow-2': _vm.active },on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }